import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IInsuranceCooperationState } from 'Redux/Slices/InsuranceCooperation/InsuranceCooperationSlice';

export const setInsuranceProvider = (state: Draft<IInsuranceCooperationState>, { payload }: PayloadAction<{ provider: string }>) => {
    state.updatedAt = Date.now();
    state.provider = payload.provider;
};
